export const VERIFY_ORGANIZATION = (org_id) => `/api/organizations/verify/${org_id}`;